module.exports = __webpack_public_path__ + "static/media/desktop.ef7245d2.jpg";